import { UserRole, highestRole, ROLE_RANK } from '@myapp/contract'

export function canCreateUser(actorRoles: UserRole[], targetRoles: UserRole[]): boolean {
  const actor = highestRole(actorRoles)
  if (actor === 'SUPERUSER') return true
  return targetRoles.every((t) => ROLE_RANK[actor] > ROLE_RANK[t])
}

export function canEditUser(actorRoles: UserRole[], targetRoles: UserRole[]): boolean {
  const actor = highestRole(actorRoles)
  if (actor === 'SUPERUSER') return true
  return targetRoles.every((t) => ROLE_RANK[actor] > ROLE_RANK[t])
}

export function canDeleteUser(actorRoles: UserRole[], targetRoles: UserRole[]): boolean {
  const actor = highestRole(actorRoles)
  if (actor === 'SUPERUSER') return true
  if (actor === 'DIRECTOR') return targetRoles.every((t) => ROLE_RANK[t] < ROLE_RANK['DIRECTOR'])
  return false
}

export const canArchiveUser = canDeleteUser
export const canRestoreUser = canDeleteUser

export function creatableRoles(actorRoles: UserRole[]): UserRole[] {
  const actor = highestRole(actorRoles)
  if (actor === 'SUPERUSER') return ['WORKER', 'MANAGER', 'DIRECTOR', 'SUPERUSER']
  if (actor === 'DIRECTOR') return ['WORKER', 'MANAGER']
  if (actor === 'MANAGER') return ['WORKER']
  return []
}

export function canManageUsers(roles: UserRole[]): boolean {
  return roles.some((r) => r === 'MANAGER' || r === 'DIRECTOR' || r === 'SUPERUSER')
}
